/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<circle pid="0" _fill="#C4FFF9" fill-rule="nonzero" cx="75" cy="75" r="40"/>'
  }
})
